import StoreIcon from '@mui/icons-material/Store';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import BolIcon from '../../svg-icons/BolIcon.jsx';
import BricoMarcheIcon from '../../svg-icons/BricoMarcheIcon';
import CarrefourIcon from '../../svg-icons/CarrefourIcon';
import CasanoovIcon from '../../svg-icons/CasanoovIcon';
import CasanoovProIcon from '../../svg-icons/CasanoovProIcon';
import CazebooIcon from '../../svg-icons/CazebooIcon';
import MaisonsDuMondeIcon from '../../svg-icons/MaisonsDuMondeIcon.jsx';
import MPAllegroIcon from '../../svg-icons/MPAllegroIcon';
import MPAmazonIcon from '../../svg-icons/MPAmazonIcon';
import MPBricodepotIcon from '../../svg-icons/MPBricodepotIcon';
import MPBricoIcon from '../../svg-icons/MPBricoIcon.jsx';
import MPBricomanIcon from '../../svg-icons/MPBricomanIcon.jsx';
import MPButIcon from '../../svg-icons/MPButIcon';
import MPCastoramaIcon from '../../svg-icons/MPCastoramaIcon.jsx';
import MPCDiscountIcon from '../../svg-icons/MPCDiscountIcon';
import MPEpriceIcon from '../../svg-icons/MPEpriceIcon';
import MPHome24Icon from '../../svg-icons/MPHome24Icon';
import MPHornbachIcon from '../../svg-icons/MPHornbachIcon.jsx';
import MPKauflandIcon from '../../svg-icons/MPKauflandIcon';
import MPLeclercIcon from '../../svg-icons/MPLeclercIcon';
import MPLeroymerlinIcon from '../../svg-icons/MPLeroymerlinIcon';
import MPManomanoIcon from '../../svg-icons/MPManomanoIcon';
import MPObiIcon from '../../svg-icons/MPObiIcon';
import MPPraxisIcon from '../../svg-icons/MPPraxisIcon.jsx';
import MPWortenIcon from '../../svg-icons/MPWortenIcon';
import MPXXXLutzIcon from '../../svg-icons/MPXXXLutzIcon.jsx';
import SicaanIcon from '../../svg-icons/SicaanIcon';
import TeractIcon from '../../svg-icons/TeractIcon';
import TiktokShopIcon from '../../svg-icons/TiktokShopIcon';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectBrandIcon = (props) => {
  const { brand, type } = props;
  switch (brand) {
    case 'Casanoov':
      return type === 'C' ? (
        <CasanoovIcon {...props} />
      ) : (
        <CasanoovProIcon {...props} />
      );
    case 'Cazeboo':
      return <CazebooIcon {...props} />;
    case 'Sicaan':
      return <SicaanIcon {...props} />;
    case 'Allegro':
      return <MPAllegroIcon {...props} />;
    case 'ePrice':
      return <MPEpriceIcon {...props} />;
    case 'LeroyMerlin':
      return <MPLeroymerlinIcon {...props} />;
    case 'Kaufland':
      return <MPKauflandIcon {...props} />;
    case 'Worten':
      return <MPWortenIcon {...props} />;
    case 'Bricodepot':
      return <MPBricodepotIcon {...props} />;
    case 'Leclerc':
      return <MPLeclercIcon {...props} />;
    case 'Home24':
      return <MPHome24Icon {...props} />;
    case 'Amazon':
      return <MPAmazonIcon {...props} />;
    case 'But':
      return <MPButIcon {...props} />;
    case 'CDiscount':
      return <MPCDiscountIcon {...props} />;
    case 'ManoMano':
      return <MPManomanoIcon {...props} />;
    case 'Bricoman':
      return <MPBricomanIcon {...props} />;
    case 'Brico':
      return <MPBricoIcon {...props} />;
    case 'Praxis':
      return <MPPraxisIcon {...props} />;
    case 'Hornbach':
      return <MPHornbachIcon {...props} />;
    case 'Castorama':
      return <MPCastoramaIcon {...props} />;
    case 'XXXLutz':
      return <MPXXXLutzIcon {...props} />;
    case 'OBI':
      return <MPObiIcon {...props} />;
    case 'Carrefour':
      return <CarrefourIcon {...props} />;
    case 'Teract':
      return <TeractIcon {...props} />;
    case 'TikTokShop':
      return <TiktokShopIcon {...props} />;
    case 'BricoMarche':
      return <BricoMarcheIcon {...props} />;
    case 'Bol':
      return <BolIcon {...props} />;
    case 'MaisonsduMonde':
      return <MaisonsDuMondeIcon {...props} />;
    case 'Unknown':
    default: // Unknown
      return <StoreIcon color="action" {...props} />;
  }
};

const BrandIcon = (props) => {
  const { brand, type } = props;
  if (!brand || !type) {
    return <StoreIcon color="action" {...props} />;
  }
  return (
    <ErrorBoundary fallback={<InternalServerError />} source="BrandIcon">
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }} {...props}>
        <Tooltip
          placement="right"
          title={`${brand}${type === 'P' ? ' PRO' : ''}`}
        >
          <span>{selectBrandIcon(props)}</span>
        </Tooltip>
      </Box>
    </ErrorBoundary>
  );
};

export default BrandIcon;
